import { CgsEvent } from '@cgs/wge';

export class SpinEvent extends CgsEvent {}
